import { Component, ɵConsole } from '@angular/core';
import { NavController, LoadingController, NavParams, AlertController, ToastController } from 'ionic-angular';
import { DetailAdvPage } from '../';
import { User, Master, Advance } from '@providers/advance_providers/index';

@Component({
  selector: 'page-adv-employee',
  templateUrl: 'page.html'
})
export class AdvEmployeePage {

  user:any={};
  params:any={};
  list:any=[];
  user_nik=0;
  employee_name='';
  total_amount=0;

  employee : any={};

  constructor(
    public navCtrl: NavController,
    public masterApi: Master,
    public advanceApi : Advance,
    public userApi: User,
    public loadingCtrl: LoadingController,
    public navParams: NavParams,
    public alertCtrl: AlertController,
    public toastCtrl:ToastController
    ) {
    this.user_nik = this.navParams.get('user_nik');
    this.employee_name = this.navParams.get('employee_name');
    this.user = this.userApi.data;

    this.getList();
  }

  doRefresh(refresher){
    refresher.complete();
    this.getList();
  }

  getDetailEmployee(){
    let loading = this.loadingCtrl.create({
      content: 'Please wait...'
    });
    loading.present();
    let params : any = {user_nik:this.user_nik}
    this.masterApi.getEmployee(params).subscribe((resp:any) => {
      this.employee = resp.data[0];

      console.log("data employee di klik = ",this.employee.name);
      console.log("employe detail => ", this.employee)
    });
    loading.dismiss();
  }
  
  getList(){
    let loading = this.loadingCtrl.create({
      content: 'Please wait...'
    });
    loading.present();

    let params = {
      user_nik : this.user_nik
    }
    this.advanceApi.get(params).subscribe((resp:any) => {
      if (resp.data!=''){
        this.getDetailEmployee();
        this.list = resp.data;
        this.total_amount = resp.total_amount.total_amount;

        loading.dismiss();
        console.log("total amount => ", this.total_amount);
      }else{
        this.navCtrl.pop();
        this.presentToast(this.employee_name+" tidak memiliki data advance !");
        loading.dismiss();
      }
    }, (err) => {
      loading.dismiss();
      this.presentToast('ERROR');
      console.log(err);
    });
  }

  toDetailAdvance(id, item){
    this.navCtrl.push(DetailAdvPage, {
      cb_request_id:id,
      item:item
    });
  }

  presentToast(msg){
    this.toastCtrl.create({
      message: msg,
      duration: 3000,
      position: 'top'
    }).present();
  }

  localFormating(v){
    v = parseFloat(v);
    v = v.toLocaleString(['ban', 'id']);
    if(v=='NaN'){
      v='-';
    }
    return v;
  }
  localDateFormating(v){
    v = new Date(v);
    v = v.toLocaleString(['ban', 'id']);
    return v;
  }

}



// WEBPACK FOOTER //
// ./src/pages/advance_mobile/adv_employee/page.ts